var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Icon from "../Icon";
var Svg = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var Menu = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "#E2665C" : _b, _c = _a.width, width = _c === void 0 ? 24 : _c, _d = _a.height, height = _d === void 0 ? 24 : _d, className = _a.className;
    return (React.createElement("div", { style: { width: width, height: height }, className: className },
        React.createElement(Svg, { viewBox: "0 0 24 24 " },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.9999 9H4.99988V11H18.9999V9ZM19.0004 14H5.00037V16H19.0004V14Z", fill: color }))));
};
var templateObject_1;
